import {AiOutlineUnorderedList} from 'react-icons/ai';
import {IconBaseProps} from "react-icons";

export const BillableUnitIcon = (props: IconBaseProps) => {

    return (
        <AiOutlineUnorderedList {...props}/>
    );
};
